import React, { Component } from "react";
import { connect } from "react-redux";

/*
 * コンター凡例作成
 * @param {Array} names 凡例名
 * @return {String} 凡例データ
 * @since hara 2021-06-28
 */
export const createColorLgd = (names) => {
    const colors = [
        "#0016b7", //青
        "#005cff",
        "#00a4ff", //水
        "#00e2d6",
        "#00b248", //緑
        "#8fc31f",
        "#fff100", //黄
        "#f2a700",
        "#ef6600",
        "#E60012", //赤
    ];

    let lgd = [];
    colors.forEach((el, index) => {
        lgd.push({ name: names[index], color: el });
    });

    return lgd;
};

//確率コンター凡例
export const probLgd = createColorLgd(["90 ~ 100", "80 ~ 90", "70 ~ 80", "60 ~ 70", "50 ~ 60", "40 ~ 50", "30 ~ 40", "20 ~ 30", "10 ~ 20", "0 ~ 10"]);

/*
 * 確率からコンター色を算出する
 * @param {Array} probs 予測確率(element of probs: 0<= n <= 1.0)
 * @return {String} コンター色
 * @since kawai 2020-09-09
 */
export const getContColor = (probs) => {
    let level = 1;
    if (probs) {
        const n = Math.max(...probs);
        level = Math.ceil(n * probLgd.length);
        if (level === 0) {
            level = 1;
        }
    }

    return probLgd[probLgd.length - level].color;
};

const mapStateToProps = (state) => {
    return {};
};

/*
 * 凡例
 * @since hara 2021-02-10
 */
class Lgd extends Component {
    render() {
        let data = this.props.data;
        if (this.props.cat === "prob") data = probLgd;

        let thText;
        switch (this.props.cat) {
            case "geo":
                thText = "地質";
                break;
            case "prob":
                thText = "予測確率 [%]";
                break;
            case "dist":
                thText = "距離 [m]";
                break;
            case "dep":
                thText = "深度 [m]";
                break;
        }

        const wrapStyle = {
            width: this.props.width === "all" ? "100%" : "15.5rem",
            height: this.props.isRsltCs ? "23rem" : "30rem",
            overflowY: "scroll",
        };

        /*
         * 表示用予測確率取得
         * 予測確率がnullの場合（学習領域内に設定地質が含まれない場合）'-'を返す
         * @param {number} prob 予測確率
         * @since hara 2021-09-30
         */
        const getProb = (prob) => {
            return prob === null ? "-" : (prob * 100).toFixed(2);
        };

        return (
            <div>
                <div className="LgdWrap" style={wrapStyle}>
                    <table className="autoTable">
                        <thead>
                            <tr>
                                <th className="tsLgd">{thText}</th>
                                {this.props.cat === "geo" && <th>予測確率 [%]</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((el, index) => (
                                <tr className={this.props.cat === "geo" ? (el.ID === this.props.cellInfo.geoID ? "selRow" : "") : ""} key={el.ID}>
                                    <td>
                                        <div className="l-row">
                                            <div className="lgd" style={{ backgroundColor: el.color }}></div>
                                            <p className="l-mlS brTxt">{this.props.cat === "geo" ? el.ID + " : " + el.name : el.name}</p>
                                        </div>
                                    </td>
                                    {this.props.cat === "geo" && <td className="brTxt txtR">{this.props.cellInfo.prob.length ? getProb(this.props.cellInfo.prob[index]) : "-"}</td>}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {this.props.isRsltCs && (
                    <div>
                        <p className="l-mtS">{"地表標高 [m]：" + this.props.cellInfo.GL}</p>
                        <p className="l-mtS">{"地下水標高 [m]：" + this.props.cellInfo.WL}</p>
                        <p className="l-mtS">{"セル標高 [m]：" + this.props.cellInfo.elev}</p>
                        <p className="l-mtS">{"セル深度 [m]：" + this.props.cellInfo.dep}</p>
                    </div>
                )}
            </div>
        );
    }
}

export default connect(mapStateToProps)(Lgd);
